import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id", "gradientTransform"]
const _hoisted_2 = ["stop-color"]
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["stop-color"]
const _hoisted_6 = ["stop-color"]

import { PropType } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GradientDefs',
  props: {
  id: {
    type: String,
    required: true,
  },
  type: {
    type: String as PropType<'linear' | 'radial'>,
  },
  color1: {
    type: String,
    required: true,
  },
  color2: {
    type: String,
    required: true,
  },
  rotate: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.type === 'linear')
    ? (_openBlock(), _createElementBlock("linearGradient", {
        key: 0,
        id: __props.id,
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "0%",
        gradientTransform: `rotate(${__props.rotate},0.5,0.5)`
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": __props.color1
        }, null, 8, _hoisted_2),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": __props.color2
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("radialGradient", {
        key: 1,
        id: __props.id
      }, [
        _createElementVNode("stop", {
          offset: "0%",
          "stop-color": __props.color1
        }, null, 8, _hoisted_5),
        _createElementVNode("stop", {
          offset: "100%",
          "stop-color": __props.color2
        }, null, 8, _hoisted_6)
      ], 8, _hoisted_4))
}
}

})